import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showTicketFormUi } from '../../../../../../app/store/slices/ticket/ticket';
import TicketList from './TicketList';
import PlatformFeesPayable from './forms/PlatformFeesPayable';
import AlertDialog from '../../../../../../components/Dialog/AlertDialog';
import CreateTicket from './CreateTicket';
import NoCreatedEvent from '../../../../user-dashboard/my-events/NoCreatedEvent';
import styles from '../../../../../../styles/module/TicketForm.module.css';

export default function TicketDetails() {
    const dispatch = useDispatch();
    const { tickets, showTicketForm, showTicketList } = useSelector((state) => state.ticket);
    const [openCommissionDialog, setOpenCommissionDialog] = useState(false);

    function handleTheFormState() {
        dispatch(showTicketFormUi({ showTicketForm: true }));
    }

    return (
        <div noValidate id={styles.createTicketForm}>
            <div className={styles.ticketFormContainer}>
                {!showTicketForm && !tickets?.length > 0 && (
                    <NoCreatedEvent
                        title="No tickets created yet"
                        description="Create your first ticket to get started."
                        shouldShowButton={true}
                        onClick={handleTheFormState}
                        btnName="Create Ticket"
                    />
                )}

                {/* Only load if show ticket form is true */}
                {showTicketForm && <CreateTicket />}

                {/* Only load if show ticket form is false and created tickets length greater than 0 */}
                {!showTicketForm && tickets?.length > 0 && !showTicketList && <TicketList />}
            </div>

            {/* 
            Todo: Connect this module when backend ready.
            Show this module only one time when user create paid ticket. if free ticket then dont show this. And after submitting the value of this field keep it off permannently.
             */}
            <AlertDialog
                open={openCommissionDialog}
                onCancel={() => setOpenCommissionDialog(false)}
                onConfirm={() => setOpenCommissionDialog(false)}
                dialogContentSx={{ overflow: 'visible' }}
                dialogTitle="Platform fees payable by"
            >
                <PlatformFeesPayable />
            </AlertDialog>
        </div>
    );
}
